import { FormikProps } from "formik";
import { createContext, useContext, useEffect, useRef } from "react";

export const ConsentReadOnlyContext = createContext(false);

export const useConsentReadOnly = (): boolean =>
  useContext(ConsentReadOnlyContext);

export interface ConsentFormSyncOptions<T> {
  onValuesChange?: (values: T) => void;
  /** Host form's submit count; each increment submits this form to reveal its errors. */
  submitCount?: number;
}

export const useConsentFormSync = <T>(
  formik: FormikProps<T>,
  { onValuesChange, submitCount }: ConsentFormSyncOptions<T>
): void => {
  // The host may already have been submitted on another tab; only a submit
  // made while this form is mounted should reveal its errors.
  const seenSubmitCount = useRef(submitCount);

  useEffect(() => {
    onValuesChange?.(formik.values);
  }, [formik.values]);

  useEffect(() => {
    if (submitCount && submitCount !== seenSubmitCount.current) {
      seenSubmitCount.current = submitCount;
      void formik.submitForm();
    }
  }, [submitCount]);
};
